import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';

gsap.registerPlugin( ScrollTrigger, CustomEase, DrawSVGPlugin );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      function createAnimation( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
        if ( ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) || ( typeof elements === 'object' && elements.length > 0 ) ) {
          gsap.set( elements, startAnimationObj );

          const triggers = ScrollTrigger.batch( elements, {
            toggleClass: 'js-animated',
            once: true,
            start: start,
            onEnter: ( triggerElements ) => {
              animationFunction( triggerElements, 'original' );
            },
          } );

          ScrollTrigger.addEventListener( 'refreshInit', () => {
            triggers.forEach( ( trigger, index ) => {
              if ( trigger.progress > 0 ) {
                animationFunction( [trigger.trigger], 'refresh' );
              }
            } );
          } );
        }
      }

      // global animations in animate will load in after running common.js init function, all component javascript, and before common.js finalize function.
      // This should improve animations loading in and fix odd start times due to load order
      /*
       * Fade on scroll
       */
      const fadeUpClasses = '.js-fade:not(.js-ignore)';
      function fadeUpTimeline( elements ) {
        $( elements ).each( function( index, element ) {
          const tl = gsap.timeline();
          /*
            * The following .to functions are the equivalent of
            * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
            */

          /* Opacity style and transitions */
          tl.to( element, {
            autoAlpha: 1, // property/value
            duration: 0.35, // duration e.g. 0.35s
            ease: '0.25,0.1,0.25,1', // timing function e.g. ease
            stagger: 0.1, // delay e.g 0.1s
          }, 0 );

          /* Transform style and transitions */
          tl.to( element, {
            y: 0, // property/value
            duration: 1, // duration e.g. 1s
            ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
            stagger: 0.1, // delay e.g 0.1s
          }, 0 );
        } );
      }
      createAnimation( fadeUpClasses, {autoAlpha: 0, y: 25}, fadeUpTimeline );


      const fadeUpGroupClasses = '.js-fade-group--up';
      $( fadeUpGroupClasses ).each( function() {
        gsap.set( $( this ).find( '> *:not(.js-ignore)' ), {opacity: 0, y: 25} );
        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {opacity: 1, stagger: 0.25, ease: '0.25,0.1,0.25,1'} );
          },
        } );

        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {y: 0, stagger: 0.25, ease: '0, 0, 0.58, 1.0'} );
          },
        } );
      } );

      const fadeLeftGroupClasses = '.js-fade-group--left';
      $( fadeLeftGroupClasses ).each( function() {
        gsap.set( $( this ).find( '> *:not(.js-ignore)' ), {opacity: 0, x: -25} );
        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {opacity: 1, stagger: 0.25, ease: '0.25,0.1,0.25,1'} );
          },
        } );

        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {x: 0, stagger: 0.25, ease: '0, 0, 0.58, 1.0'} );
          },
        } );
      } );

      /*
       * Reveal on scroll
       */
      function reveal( elements ) {
        gsap.to( elements,
            {
              clipPath: 'inset(0% 0% 0% 0%)',
              duration: 1.5,
              ease: '0, 0, 0.58, 1.0',
              stagger: 0.2, // delay e.g 0.2s
            },
        );
      }

      const revealRightClasses = '.js-reveal-right:not(.js-ignore)';
      createAnimation( revealRightClasses, {clipPath: 'inset(0 100% 0 0)'}, reveal );

      const revealLeftClasses = '.js-reveal-left:not(.js-ignore)';
      createAnimation( revealLeftClasses, {clipPath: 'inset(0 0 0 100%)'}, reveal );

      const revealRightGroupClass = '.js-reveal-right--group';
      $( revealRightGroupClass ).each( function() {
        gsap.set( $( this ).find( '> *:not(.js-ignore)' ), {clipPath: 'inset(0 100% 0 0)'} );
        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {clipPath: 'inset(0% 0% 0% 0%)', duration: 1.5, ease: '0, 0, 0.58, 1.0', stagger: 0.2} );
          },
        } );

        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {clipPath: 'inset(0% 0% 0% 0%)', duration: 1.5, ease: '0, 0, 0.58, 1.0', stagger: 0.2} );
          },
        } );
      } );

      /*
       * Float
       */
      function float( elements ) {
        const tl = gsap.timeline();

        tl.to( elements, {
          opacity: 1, // property/value
          duration: 1.75, // duration e.g. 0.35s
          ease: '0, 0, 0.58, 1.0', // timing function e.g. ease
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );

        tl.to( elements, {
          y: 0, // property/value
          duration: 2, // duration e.g. 1s
          ease: '.38, 1.75, .37, .87', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }

      const floatClasses = '.js-float:not(.js-ignore)';
      createAnimation( floatClasses, {opacity: 0, y: 60}, float );
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
